import { render, staticRenderFns } from "./RecentSearchComponent.vue?vue&type=template&id=8274ed5c"
import script from "./RecentSearchComponent.vue?vue&type=script&lang=js"
export * from "./RecentSearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports